export default __webpack_public_path__ + "media/images/user_photos/104-9884ad292289769a2c1eaad96ccbb031.jpg";